import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faCheck from '@fortawesome/fontawesome-pro-light/faCheck';
import faExclamation from '@fortawesome/fontawesome-pro-light/faExclamation';

import { setStep, fetchReservationData } from '../store/actions';
import ReservationStatus from '../enums/ReservationStatus';
import T from './Translate';
import withLocalize from '../withLocalize';

class Step5 extends Component {

	componentWillMount() {
		this.props.dispatch(setStep(5));
	}

	componentDidMount() {
		if (!this.props.reservationStatus) {
			this.props.dispatch(setStep(1));
		}
	}

	resetSearch = () => {
		this.props.dispatch(setStep(1));
		this.props.dispatch(fetchReservationData());
	};

	render() {
		const { reservationStatus, email, phone, closingTime } = this.props;

		const Subtitle = withLocalize(ReservationStatus.getSubtitle(reservationStatus));
		const Subtitle2 = withLocalize(ReservationStatus.getSubtitle2(reservationStatus));

		return (
			<section className="container final-step">
				<div className="final-step-icon">
					{ReservationStatus.isSuccess(reservationStatus) ?
					<div>
						<div className="final-step-icon__bg final-step-icon__bg--under final-step-icon__bg--success" />
						<div className="final-step-icon__bg final-step-icon__bg--under2 final-step-icon__bg--success" />
						<div className="final-step-icon__bg final-step-icon__bg--success" />
						<FontAwesomeIcon icon={faCheck} className="final-step-icon__icon" />
					</div>
					:
					<div>
						<div className="final-step-icon__bg final-step-icon__bg--under final-step-icon__bg--error"/>
						<div className="final-step-icon__bg final-step-icon__bg--under2 final-step-icon__bg--error"/>
						<div className="final-step-icon__bg final-step-icon__bg--error"/>
						<FontAwesomeIcon icon={faExclamation} className="final-step-icon__icon"/>
					</div>
					}
				</div>

				<h1 className="final-step__title relative"><T id={ReservationStatus.getTitle(reservationStatus)} /></h1>
				{!!Subtitle &&
				<h2 className="final-step__subtitle relative"><Subtitle closingTime={closingTime}/></h2>
				}
				<h2 className="final-step__subtitle relative"><Subtitle2 email={email} phone={phone} /></h2>

				{!ReservationStatus.isSuccess(reservationStatus) &&
					<div className="text-center final-step__back relative">
						<button onClick={this.resetSearch} className="button button--bg"><T id="Step5.backToFirstStep" /></button>
					</div>
				}
			</section>
		);
	}
}

export default compose(
	connect((state) => ({
		reservationStatus: state.app.reservationStatus,
		email: state.app.email,
		phone: state.app.phone,
		closingTime: state.app.closingTime,
	}))
)(Step5);



// WEBPACK FOOTER //
// ./src/components/Step5.jsx